// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__VersionDetailsKey___Wf4I-{\n    width: 180px;\n}", ""]);
// Exports
exports.locals = {
	"VersionDetailsKey": "styles-module__VersionDetailsKey___Wf4I-"
};
module.exports = exports;
